import StonecodeFileTypeModel   from '@models/website/StonecodeFileTypeModel';
import StonecodeFileSourceModel from '@models/website/StonecodeFileSourceModel';
import doc                      from '@widesk-core/decorators/doc';
import WebsiteServiceModel      from '@/models/WebsiteServiceModel';
import Blamable                 from '@/models/traits/Blamable';
import { Addable }              from '@widesk-core/decorators/addable';
import { Editable }             from '@widesk-core/decorators/editable';
import { Timestampable }        from '@widesk-core/decorators/timestampable';

@doc.urnResource('stonecode_file_type_source')
@doc.path('/stonecode_file_type_sources/{?id}')
@doc.addable
@doc.editable
@doc.timestampable
abstract class AbstractStonecodeFileTypeSourceModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'type': id;
		'type.service': id;
		'type.service.serviceUrn': Urn;
		'type.reference': Website_StonecodeFileTypeReference;
		'source': id;
		'source.entityUrn': Urn;
		'type.deprecated': string;
		'type.system': string;
		'locked': string;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.model(StonecodeFileTypeModel) declare type: StonecodeFileTypeModel;
	@doc.model(StonecodeFileSourceModel) declare source: StonecodeFileSourceModel;
}

interface AbstractStonecodeFileTypeSourceModel
	extends Addable,
		Editable,
		Timestampable {}

export default AbstractStonecodeFileTypeSourceModel;
